import { axios } from '@Root/API'

export const editInit = id => {
  return axios.post(`locked-forms/${id}`)
}
